"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'Collage Density',
  description: "Determines how dense the collaging and grouping of images will be. Note that in order for this option to take any effect,\n  the option \"groupSize\" needs to be set to more than 1",
  isRelevant: function isRelevant(styleParams) {
    return styleParams.groupSize > 1;
  },
  type: _constants.INPUT_TYPES.NUMBER,
  "default": 0.8
};
exports["default"] = _default;